import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { red, grey } from '@mui/material/colors';
import { Button, Container, Dialog, Typography, CircularProgress } from '@mui/material';
import styles from './guidesQRDialogStyles';

GuidesQRDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default function GuidesQRDialog({ onClose, open, urlPDF }) {

  const [isLoading, setIsLoading] = useState(false);

  const handleDownloadPDFClick = () => {
    if(isLoading) { return; }
    setIsLoading(true);

    const link = document.createElement('a');
    link.href = urlPDF;
    link.setAttribute('target', '_blank');
    link.download = 'GuíaCódigoQR.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    setIsLoading(false);
    onClose();
  }

  const buttonStyles = {
    width: '220px',
    borderRadius: '0.5rem',
    height: '38px',
  };
  
  const activeButtonStyles = {
    ...buttonStyles,
    backgroundColor: red['A400'],
    color: 'white',
    '&:hover': {
      backgroundColor: red['A700'],
    },
  };

  const handleDialogClose = (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    onClose();
  };

  return (
    <Dialog onClose={handleDialogClose} open={open} PaperProps={{ style: { borderRadius: '16px' } }} >
      <Container style={{ padding: 30 }} >
        <Typography component="div" variant="h5" style={{ textAlign: 'center', fontWeight: 'bold', color: grey[800], marginBottom: 5 }} >
          QR generado de manera correcta
        </Typography>

        <Container style={{ display: 'flex', justifyContent: 'center', width: '100%', padding: 0, marginTop: 36, gap: 12 }}>
          <Button
            variant="standard"
            color="primary"
            onClick={() => {
              onClose();
            }}
            style={styles.cancelButton}
          >
            Cancelar
          </Button>
          <Button variant="contained" onClick={() => { handleDownloadPDFClick() }}
            sx={activeButtonStyles}>
            {
              isLoading ? <CircularProgress size={24} style={{ color: 'white' }} /> : 'Descargar código QR'
            }
          </Button>
        </Container>
      </Container>
      
    </Dialog>
  );
}